import React, { useState, useEffect } from "react";
import axios from "axios";

import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";
import { useNavigate } from "react-router-dom";

const LadgerEdit = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [ledgerData, setLedgerData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const society = localStorage.getItem("society");
  const navigate = useNavigate();
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    fetchLedgerData();
  }, []);

  const fetchLedgerData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/member/get-list`,
        {
          params: {
            society,
          },
        }
      );

      setLedgerData(response.data || []);
    } catch (error) {
      console.error("Error fetching ledger data:", error);
    }
  };

  const filteredData = ledgerData.filter((item) => {
    const unitNo = (
      item.unit_no ||
      item.unitNumber ||
      ""
    ).toString();

    const memberName =
      item.member_name ||
      item.memberName ||
      item.name ||
      "";

    return (
      unitNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      memberName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const indexOfLastRecord = currentPage * pageSize;
  const indexOfFirstRecord = indexOfLastRecord - pageSize;

  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const totalPages = Math.ceil(filteredData.length / pageSize);


const handleAdd = (memberName, unitNo) => {
  navigate("/ledger-details", {
    state: {
      memberName,
      unitNo,
    },
  });
};
  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <main className="content-area">
          <SubHeader />

          <div className="container-fluid mt-3">
            <div className="card shadow-sm border-0">

              {/* Header */}
              <div className="card-header bg-white">
                <div className="row align-items-center">

                  <div className="col-md-3">
                    <h5 className="fw-bold mb-0">
                      
                    </h5>
                  </div>

                  <div className="col-md-5">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by Unit No or Member Name..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>

                  <div className="col-md-4 d-flex justify-content-end align-items-center">

                    <span className="me-2">
                      Show
                    </span>

                    <select
                      className="form-select"
                      style={{ width: "90px" }}
                      value={pageSize}
                      onChange={(e) => {
                        setPageSize(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>

                    <span className="ms-2">
                      Entries
                    </span>

                  </div>

                </div>
              </div>

              {/* Table */}
              <div className="table-responsive">
                <table className="table table-hover table-bordered mb-0">
                  <thead className="table-light">
                    <tr>
                      <th width="80">Sr No</th>
                      <th>Unit Number</th>
                      <th>Member Name</th>
                      <th width="120">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentRecords.length > 0 ? (
                      currentRecords.map((item, index) => {
                        const unitNo =
                          item.unit_no ||
                          item.unitNumber ||
                          "";

                        const memberName =
                          item.member_name ||
                          item.memberName ||
                          item.name ||
                          "";

                        return (
                          <tr key={index}>
                            <td>
                              {indexOfFirstRecord +
                                index +
                                1}
                            </td>

                            <td>{unitNo}</td>

                            <td>{memberName}</td>

                            <td>
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() =>
                                  handleAdd(
                                    memberName,
                                    unitNo
                                  )
                                }
                              >
                                Select
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan="4"
                          className="text-center py-4"
                        >
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Footer */}
              <div className="card-footer bg-white">
                <div className="row align-items-center">

                  <div className="col-md-6">
                    Showing{" "}
                    <strong>
                      {filteredData.length === 0
                        ? 0
                        : indexOfFirstRecord + 1}
                    </strong>{" "}
                    to{" "}
                    <strong>
                      {Math.min(
                        indexOfLastRecord,
                        filteredData.length
                      )}
                    </strong>{" "}
                    of{" "}
                    <strong>
                      {filteredData.length}
                    </strong>{" "}
                    entries
                  </div>

                  <div className="col-md-6">
                    <nav>
                      <ul className="pagination justify-content-end mb-0">

                        <li
                          className={`page-item ${
                            currentPage === 1
                              ? "disabled"
                              : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPage(
                                currentPage - 1
                              )
                            }
                          >
                            Previous
                          </button>
                        </li>

                        {Array.from(
                          { length: totalPages },
                          (_, i) => (
                            <li
                              key={i}
                              className={`page-item ${
                                currentPage === i + 1
                                  ? "active"
                                  : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  setCurrentPage(i + 1)
                                }
                              >
                                {i + 1}
                              </button>
                            </li>
                          )
                        )}

                        <li
                          className={`page-item ${
                            currentPage === totalPages ||
                            totalPages === 0
                              ? "disabled"
                              : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              setCurrentPage(
                                currentPage + 1
                              )
                            }
                          >
                            Next
                          </button>
                        </li>

                      </ul>
                    </nav>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default LadgerEdit;